import React from 'react';
import get from 'lodash/get';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { onChangeHandler, defaultChangeHandler } from './helpers';

const FormikConnector = Component => {
	const propTypes = {
		/** Input name the Formik field use to associate the value */
		name: PropTypes.string.isRequired,
		/** Option callback when an onChange event is triggered, if not passed the default
		 * change flow will be applied to the the Field. If passed, this handler will be invoked
		 * and the third parameter passed will be the `setValues` provided by Formik so the user
		 * is reponsible of setting the right values
		 */
		onChange: PropTypes.func,
		customErrorProp: PropTypes.string,
		customValueProp: PropTypes.string,
		customOnChangeProp: PropTypes.string,
	};

	const FormikConnectedField = ({
		name,
		onChange,
		customErrorProp,
		customValueProp,
		customOnChangeProp,
		...otherProps
	}) => (
		<Field
			name={name}
			render={({
				field: { value, onBlur },
				form: { errors, touched, setFieldValue, setValues },
			}) => (
				<Component
					{...otherProps}
					name={name}
					onBlur={onBlur}
					// `get` is used to make sure the `name` exists as it could
					// belong a nested structure
					{...{
						[customErrorProp || 'error']:
							get(touched, name) && get(errors, name),
						[customValueProp || 'value']: value,
						[customOnChangeProp || 'onChange']: onChange
							? onChangeHandler(setFieldValue, onChange, setValues)
							: defaultChangeHandler(setFieldValue),
					}}
				/>
			)}
		/>
	);

	FormikConnectedField.propTypes = propTypes;

	return FormikConnectedField;
};

export default FormikConnector;
